import { walletAppleUrl, walletGoogleUrl } from "core/constants/endpoints";
import HttpClient from "core/helpers/HttpClient";
import { WalletPassParams } from "domain/entity/WalletPass";

export interface AppleWalletApiResponse {
  blob: Blob;
  correlationId?: string;
}

export interface GoogleWalletApiResponse {
  url: string;
  correlationId?: string;
}

export abstract class WalletRemoteDataSource {
  abstract getAppleWalletPass(
    params: WalletPassParams
  ): Promise<AppleWalletApiResponse>;
  abstract getGoogleWalletPass(
    params: WalletPassParams
  ): Promise<GoogleWalletApiResponse>;
}

export class WalletRemoteDataSourceImpl extends WalletRemoteDataSource {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    super();
    this.httpClient = httpClient;
  }

  getAppleWalletPass = (
    params: WalletPassParams
  ): Promise<AppleWalletApiResponse> =>
    this.httpClient.request(walletAppleUrl, {
      data: {
        appId: params.appId,
        productType: params.productType,
      },
      responseType: "blob",
      factory: (
        data: BlobPart,
        headers: Record<string, string>
      ): AppleWalletApiResponse => ({
        blob: new Blob([data], { type: "application/vnd.apple.pkpass" }),
        correlationId: headers["x-correlation-id"],
      }),
    });

  getGoogleWalletPass = (
    params: WalletPassParams
  ): Promise<GoogleWalletApiResponse> =>
    this.httpClient.request(walletGoogleUrl, {
      data: {
        appId: params.appId,
        productType: params.productType,
      },
      factory: (
        data: { url: string },
        headers: Record<string, string>
      ): GoogleWalletApiResponse => ({
        url: data.url,
        correlationId: headers["x-correlation-id"],
      }),
    });
}
